// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@pace/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow";
import IconCheckmark from "@pace/XDL/Icons/IconCheckmark";
import IconTrash from "@pace/XDL/Icons/IconTrash";
import { color, mergeWithCss, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsQuoteLineCalculatorStyles.qtyCell = {
    // Undo sticky table from prestyles
    css: css`
        height: 60px;
        border-bottom: none;
        padding-top: 10px;
        ${xScreen("lte", "sm")} {
            &&& {
                position: static;
            }
        }
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.removePriceBreakIcon = {
    src: IconTrash,
    size: 16,
    color: "secondary",
    css: css`
        &:hover {
            color: ${color("danger")};
        }
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.applyDiscountIcon = {
    src: IconCheckmark,
    size: 16,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.percentIcon = {
    ...mergeWithCss(rfqQuoteDetailsQuoteLineCalculatorStyles.percentIcon, {
        size: 16,
    }),
};
rfqQuoteDetailsQuoteLineCalculatorStyles.discountStylesWrapper = {
    css: css`
        margin-top: 15px;
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.percentStylesWrapper = {
    css: css`
        margin-top: 37px;
    `,
};
rfqQuoteDetailsQuoteLineCalculatorStyles.discountLinkStylesWrapper = {
    css: css`
        ${({ displayRemovePriceBreakIcon }: any) =>
            displayRemovePriceBreakIcon ? "margin-top: 50px;" : "margin-top: 70px;"};
    `,
};
